<template>
    <LayoutSoundConsoleGrid>
        <template v-slot:elliot>
            <BaseElliotHead />
        </template>
        <template v-slot:text>
            <BaseTextCloud>
                Congratulations! You're done.
                <br><router-link style="font-size: 16px;" to="/">Navigate home</router-link>
            </BaseTextCloud>
        </template>
        <template v-slot:bottom>
        </template>
    </LayoutSoundConsoleGrid>
</template>

<script>
    import LayoutSoundConsoleGrid from './LayoutSoundConsoleGrid';
    import BaseTextCloud from './BaseTextCloud';
    import BaseElliotHead from './BaseElliotHead';

    export default {
        components: {
            BaseTextCloud,
            BaseElliotHead,
            LayoutSoundConsoleGrid
        },
    }
</script>
